import { Controller } from '@hotwired/stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ["wrapper", "copy"]

  connect() {
    if(!window.customer_logged_in){
      $('.btn-favorite-wrapper').popover()
    }
  }

  redirectToLogin(ev) {
    ev.preventDefault()
    window.location.href = "/store/login"
  }

  saveFavorite(ev) {
    ev.preventDefault()

    const favorited = this.wrapperTarget.classList.contains("favorited")
    const productId = this.wrapperTarget.dataset.id

    var url = this.data.get("url")

    url = favorited ? `${url}/${productId}` : url

    if(favorited) {
      Rails.ajax({
        url: url,
        type: "DELETE",
        success: (data) => {
          this.wrapperTarget.classList.remove("favorited")
          this.copyTarget.innerHTML = 'Favorite'
        },
        error: (error, status, xhr) => {
          console.log("Something went wrong D:")
        }
      })
    } else {
      Rails.ajax({
        url: url,
        type: "POST",
        beforeSend(xhr, options) {
          xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
          options.data = JSON.stringify({
            spree_product: {
              id: productId
            }})
          return true
        },
        success: (data) => {
          this.wrapperTarget.classList.add("favorited")
          this.copyTarget.innerHTML = 'Favorited'
        },
        error: (error) => {
          console.log("Something went wrong D:")
        }
      })
    }
  }
}
